if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				const currentQty = parseInt(qty.value);
				if ( ! qtyMinus.classList.contains('disabled') ) {
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
				}
				this.Update(currentQty - 1)
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				const currentQty = parseInt(qty.value);
				if ( ! qtyPlus.classList.contains('disabled') ) {
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
				this.Update(currentQty + 1)
			});

		}
		Update(QTY) {
		const rows = document.querySelectorAll('.product-block-prices-row');

		// 🔥 Step 1: remove all active dots ONCE
		document.querySelectorAll('.emz-product-block-prices-dot.active')
			.forEach(dot => dot.classList.remove('active'));

		// 🔥 Step 2: find matching row
		for (const row of rows) {
			const quantityEl = row.querySelector('.product-block-prices-quantity');
			const quantity = quantityEl ? Number(quantityEl.getAttribute('data-price-quantity')) : null;

			if (quantity === QTY) {
			const dot = row.querySelector('.emz-product-block-prices-dot');
			if (dot) dot.classList.add('active');
			break; // ✅ now this actually works
			}
		}
		}
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}